import { useContext, useEffect } from 'react';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import { updateCrumbs } from '@/components/bread-crumbs/update-crumb';
import { LOAD_STATUS } from '@/components/loadable';

function useDetailBreadCrumb() {
  const { activityInfo, loadStatus } = useContext(ContextProviderMenus);

  useEffect(() => {
    if (loadStatus === LOAD_STATUS.SUCCESS) return updateCrumbs(activityInfo);
  }, [activityInfo, loadStatus]);
}

export default useDetailBreadCrumb;
